<template>
  <section v-if="show" id="comment-bar" class="content-bar d-flex bg-black justify-content-center">
    <ncc-content-column :html="comment"/>
  </section>
</template>

<script>
    import NccContentColumn from "./NccContentColumn";

    export default {
        name: "NccQuestionCommentBar",
        components: {NccContentColumn},
        computed: {
            show() {
                return this.$store.getters['showComment'] && this.comment;
            },
            comment() {
                const selectedQuestion = this.$store.getters['selectedQuestion'];

                if(!selectedQuestion) {
                    return null
                }

                return selectedQuestion['comment']
            }
        }
    }
</script>
